import { useEffect, useState } from "react"

export const useFormatNumbers = (number) => {
  const fN = Intl.NumberFormat('en-US')
  const [numberF, setNumberF] = useState(null)
  
  useEffect(() => {
    setNumberF(fN.format(number))
  }, [number])

  return numberF
}